import * as actions from '../../actions/actionsTypes/anagraficheActionType';

export const inizializedStateAnagraficaRuoli = {
  response: [],
  errori: []
};

export const anagraficaRuoliReducer = (state = inizializedStateAnagraficaRuoli, action) => {
    switch (action.type){
        case actions.INIT_ANAGRAFICA_RUOLI : {
            return {
                response: [],
                errori: []
            }
        }
        case actions.INSERISCI_MODIFICA_ANAGRAFICA_SUCCESS : {
            return{
                ...state,
                response: [...state.response, action.role]
            }
        }
        case actions.INSERISCI_MODIFICA_ANAGRAFICA_FAIL : {
            return{
                ...state,
                errori: [...state.errori, action.role]
            }
        }
        default : {
            return state
        }
    }
};

